function initStickyColumns() {
  // Only run on event singles at 782px or wider
  if (!document.body.classList.contains('single-event') || window.innerWidth < 782) {
    return;
  }

  const entryContent = document.querySelector('.single-event .entry-content');
  if (!entryContent) return;

  const columnBlocks = entryContent.querySelectorAll('.wp-block-columns');

  columnBlocks.forEach((block, index) => {
    const columns = Array.from(block.children).filter((child) =>
      child.classList.contains('wp-block-column')
    );

    // Only process if there are exactly 2 columns
    if (columns.length !== 2) return;

    const [col1, col2] = columns;

    // Reset any previous styles
    col1.style.position = '';
    col2.style.position = '';
    col1.style.top = '';
    col2.style.top = '';
    col1.style.alignSelf = 'flex-start';
    col2.style.alignSelf = 'flex-start';
    col1.style.height = 'auto';
    col2.style.height = 'auto';

    // Force reflow to get accurate measurements
    void block.offsetHeight;
    void col1.offsetHeight;
    void col2.offsetHeight;

    // Wait a tick for layout to settle, especially for images
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Now measure actual content heights
        const height1 = col1.scrollHeight;
        const height2 = col2.scrollHeight;

        // Only make sticky if there's a significant height difference (at least 100px)
        if (Math.abs(height1 - height2) < 100) {
          return;
        }

        // Determine which column has less content
        const shorterCol = height1 < height2 ? col1 : col2;

        // Ensure both columns are at flex-start (don't stretch)
        col1.style.alignSelf = 'flex-start';
        col2.style.alignSelf = 'flex-start';

        // Apply sticky CSS to shorter column
        shorterCol.style.position = 'sticky';
        shorterCol.style.top = '65px';
      });
    });
  });
}

function initContributorGridReveal() {
  const grids = document.querySelectorAll('.js-event-contributors-grid');
  if (grids.length === 0) {
    return;
  }

  grids.forEach((grid) => {
    if (grid.dataset.revealBound === '1') {
      return;
    }

    grid.dataset.revealBound = '1';

    const toggle = grid.querySelector('.js-event-contributors-grid-toggle');
    if (!toggle) {
      return;
    }

    toggle.addEventListener('click', () => {
      const isExpanded = grid.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

      const expandLabel = toggle.getAttribute('data-expand-label') || 'See all contributors';
      const collapseLabel = toggle.getAttribute('data-collapse-label') || 'Show fewer contributors';
      toggle.textContent = isExpanded ? collapseLabel : expandLabel;
    });
  });
}

function initEventHeroAnchorScroll() {
  if (
    !document.body.classList.contains('single-event') ||
    document.body.dataset.eventHeroScrollBound === '1'
  ) {
    return;
  }

  document.body.dataset.eventHeroScrollBound = '1';

  const heroTargetIds = ['regForm', 'eventRecapVideo', 'eventHeaderCta'];

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) {
      return;
    }

    const requestedTargetId = link.getAttribute('href').slice(1);
    if (!heroTargetIds.includes(requestedTargetId)) {
      return;
    }

    const target =
      document.getElementById(requestedTargetId) ||
      heroTargetIds.map((targetId) => document.getElementById(targetId)).find(Boolean);

    if (!target) {
      return;
    }

    event.preventDefault();

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });

    window.history.pushState(null, '', `#${target.id}`);
  });
}

// Helper function to check if images have dimensions
function waitForImages() {
  return new Promise((resolve) => {
    const images = document.querySelectorAll('.single-event .entry-content img');

    if (images.length === 0) {
      resolve();
      return;
    }

    let loaded = 0;
    const total = images.length;

    const checkImage = () => {
      loaded++;
      if (loaded === total) {
        // Extra delay to ensure layout has settled
        setTimeout(resolve, 100);
      }
    };

    images.forEach((img) => {
      if (img.complete && img.naturalHeight !== 0) {
        checkImage();
      } else {
        img.addEventListener('load', checkImage);
        img.addEventListener('error', checkImage);
      }
    });
  });
}

// Run immediately if DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', async () => {
    initEventHeroAnchorScroll();
    await waitForImages();
    initStickyColumns();
    initContributorGridReveal();
  });
} else {
  // DOM already loaded, wait for images then run
  initEventHeroAnchorScroll();
  waitForImages().then(() => {
    initStickyColumns();
    initContributorGridReveal();
  });
}

// ALSO run on full page load as backup
window.addEventListener('load', () => {
  // Give it another 200ms for any stragglers
  setTimeout(initStickyColumns, 200);
  setTimeout(initContributorGridReveal, 200);
});

// Re-run on window resize (debounced)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    // Reset all styles first
    document.querySelectorAll('.wp-block-column').forEach((col) => {
      col.style.position = '';
      col.style.top = '';
      col.style.alignSelf = '';
      col.style.height = '';
    });
    initStickyColumns();
  }, 250);
});
